<template>
    <rkm-overlay>
        <rkm-layout-body title="Ficha de vacinação">
            <template v-slot:actions>
                <rkm-button
                    color="primary"
                    @click="$router.push({ name: 'atencao-basica-ficha-vacinacao-create' })"
                >
                    Adicionar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/atencao-basica/ficha-vacinacao/List'

export default {
    components: { List },
    props: {
        item: { type: Object, default: null }
    },
}
</script>